import React from 'react';
import NodeSymbolSelect from './NodeSymbolSelect';
import { Handle, Position } from 'reactflow';

export default function LookbackNode({ data, id }) {
  const onChange = (field, value) => {
    if (data.onChange) data.onChange(id, field, value);
  };

  return (
    <div style={{
      padding: 12,
      borderRadius: 8,
      border: '2px solid #06b6d4',
      background: 'var(--card)',
      minWidth: 220,
      fontSize: 13,
      color: 'var(--text)',
    }}>
      <div style={{ fontWeight: 700, marginBottom: 8, color: '#22d3ee' }}>
        ⏮ Lookback
      </div>
      <NodeSymbolSelect value={data.symbol} onChange={(v) => onChange('symbol', v)} />

      <select
        value={data.lookback_type || 'bars_ago'}
        onChange={(e) => onChange('lookback_type', e.target.value)}
        style={{ width: '100%', marginBottom: 6, padding: 4, background: 'var(--surface)', color: 'var(--text)', border: '1px solid var(--border)', borderRadius: 4 }}
      >
        <option value="bars_ago">N Bars Ago</option>
        <option value="highest">Highest in N Bars</option>
        <option value="lowest">Lowest in N Bars</option>
        <option value="average">Average in N Bars</option>
        <option value="change">Change Over N Bars (now − N bars ago)</option>
        <option value="pct_change">% Change Over N Bars</option>
        <option value="pct_from_highest">% Below Highest in N Bars</option>
        <option value="pct_from_lowest">% Above Lowest in N Bars</option>
      </select>

      <div style={{ display: 'flex', gap: 6, marginBottom: 6 }}>
        <select
          value={data.field || 'close'}
          onChange={(e) => onChange('field', e.target.value)}
          style={{ flex: 1, padding: 4, background: 'var(--surface)', color: 'var(--text)', border: '1px solid var(--border)', borderRadius: 4 }}
        >
          <option value="close">Close</option>
          <option value="open">Open</option>
          <option value="high">High</option>
          <option value="low">Low</option>
          <option value="volume">Volume</option>
        </select>
        <input
          type="number"
          min={1}
          value={data.period ?? 1}
          onChange={(e) => onChange('period', Math.max(1, parseInt(e.target.value, 10) || 1))}
          style={{ width: 74, padding: 4, background: 'var(--surface)', color: 'var(--text)', border: '1px solid var(--border)', borderRadius: 4, fontFamily: 'var(--font-mono)' }}
        />
      </div>

      <div style={{ fontSize: 10, color: 'var(--muted)', lineHeight: 1.4 }}>
        The dropdown above is only used if nothing is plugged into the left input. Connect an indicator, data, or other node into the left input to look back on that instead of price.
      </div>

      <Handle type="target" position={Position.Left} id="source" style={{ background: '#06b6d4' }} />
      <Handle type="source" position={Position.Right} id="output" style={{ background: '#06b6d4' }} />
    </div>
  );
}
